
fx.ns("shared.stage", class FrameArea extends shared.stage.Area {
    
	constructor(page, model, parentContainer, preview)
	{
        super(page, model, parentContainer, "", preview);

        this.listenUpdates(this.creation, true);
   }
  
    /***************** Actions *****************/

    get frame()
    {
    return this.element;
    }

    get single()
    {
    return true;
    }

   

  /***************** Overrides *****************/


    create()
    {
        super.create();

        // add border wood / white / black
        this.updateBorder();
    }

    // the border follows the option : a poster opened without frame and switched to
    // "Cadre bois" afterwards needs its border created then, not only at create()
    updateBorder()
    {
        let asset = this.creation.borderAsset;

        if (!asset)
        {
            if (this.frameBorder)
                this.frameBorder.visible = false;
            return;
        }

        if (!this.frameBorder)
        {
            this.frameBorder = new fx.components.Image({data: asset, className: "frameBorder"});
            this.stageContainer.addChild(this.frameBorder, this.borderViewport);
            return;
        }

        this.frameBorder.data = asset;
        this.frameBorder.viewport(this.borderViewport);
        this.frameBorder.visible = true;
    }

    onDataUpdated(action)
    {
        super.onDataUpdated(action);
        
        if (action.model == this.creation && action.type == "update" && (action.impacts("formatid") || action.impacts("optionid")))
            this.updateBorder();
            
    }

    get borderViewport()
    {
        return {
                    top : -this.creation.borderSize, 
                    left :-this.creation.borderSize, 
                    height : this.height() + (2*this.creation.borderSize) + 2, 
                    width : this.width() + (2*this.creation.borderSize) + 2
                };
    }
 
});